module.exports = __webpack_public_path__ + "static/media/js.0fe02b37.svg";